import React from 'react'

import { Close } from '../../../../../icons'
import { CloseWrapper, Container, Title } from './styles'

export interface ModalHeaderProps {
  className?: string
  onClose?: () => void
  children?: React.ReactNode
}

export const ModalHeader = ({
  className,
  children,
  onClose,
}: ModalHeaderProps) => {
  return (
    <Container className={className} hasCloseButton={!!onClose}>
      <Title hasCloseButton={!!onClose}>{children}</Title>
      {onClose && (
        <CloseWrapper onClick={onClose}>
          <Close />
        </CloseWrapper>
      )}
    </Container>
  )
}
